<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M4.667 7.334v17.333h22.667V7.334H4.667zm-.667-2c-.736 0-1.333.597-1.333 1.333v18.667c0 .736.597 1.333 1.333 1.333h24c.737 0 1.334-.597 1.334-1.333V6.667c0-.736-.597-1.333-1.334-1.333H4zm10.667 14.333a1 1 0 011-1h6.5a1 1 0 110 2h-6.5a1 1 0 01-1-1zm-4.142-8.056a1 1 0 00-1.383 1.446L12.22 16l-3.078 2.944a1 1 0 101.383 1.445l3.833-3.667a1 1 0 000-1.445l-3.833-3.667z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'webSystemTerminalOutline'
}
</script>
